import axios from 'axios';

export default async (commit, getters, feedback) => {
    let data;
    let payload = {
        userInfo: {
            firstName: getters.userInfo.firstName,
            lastName: getters.userInfo.lastName,
            email: getters.userInfo.email,
        },
        ...(!!getters.purchaseInfo.partnerAccountId && {partnerAccountId: getters.purchaseInfo.partnerAccountId}),
        feedback,
        ...(!!window.Sentry.lastEventId() && {sentryId: window.Sentry.lastEventId()})
    };

    try {
        ({ data } = await axios.post(`/api/v1/message/feedback`, {
            ...payload
        }));
        return true;
    } catch (error) {
        window.Sentry.logError(error, {server_event_id: error.response.data.eventId});
        return false;
    }
}
